import { NotificationTypesEnum } from "../enums/NotificationTypesEnum";
import { AppNotification } from "./AppNotification";

export class SecurityNotification extends AppNotification {
    notificationType: NotificationTypesEnum = NotificationTypesEnum.Security;
    errorDetails: string;

    constructor(data: any) {
        super(data);
        if (data.ErrorDetails) this.errorDetails = data.ErrorDetails;
    }
}
